module.exports = __webpack_public_path__ + "img/9.8ee72b04.jpg";